import React from 'react';
import Rating from 'react-rating';
import { FaStar } from 'react-icons/fa'

const SingleReview = (props) => {
    const { review } = props;
    const { id, name, rating, comments, picture } = review;

    return (
        <div className='card'>
            <div className='card-img'>
                <img src={picture} alt="" />
            </div>
            <div className='card-info'>
                <p>Rating:
                    <Rating
                        initialRating={rating}
                        emptySymbol={<FaStar></FaStar>}
                        fullSymbol={<FaStar style={{ color: 'goldenrod' }}></FaStar>}
                        readonly
                    ></Rating>
                </p>
                <h3>{name}</h3>
                <p>{comments}</p>
            </div>
        </div>
    );
};

export default SingleReview;